module.exports = __webpack_public_path__ + "img/die-3.98077dbe.svg";